import {addImageToGallery} from '../api/gallery/addImageToGallery';
import {getSignedStorageUrl} from '../api/gallery/getSignedStorageUrl';
import {uploadFileToAwsS3} from '../api/gallery/uploadFileToAwsS3';

export async function uploadGalleryImage(file, progress = () => {}) {
  progress(0);

  const {headers, url, key} = await getSignedStorageUrl();
  await uploadFileToAwsS3(url, file, headers, percentage => progress(Math.round(percentage * 100)));

  progress(100);

  const data = await addImageToGallery(key);
  if (data.url) {
    return data.url;
  } else {
    throw Error(data.message);
  }
}
